import { MessageResponse } from "./message-response"

export const makeMessageViewModel = (message: MessageResponse): MessageViewModel => ({
  ...message,
})

export type MessageViewModel = MessageResponse
